import { type FocusEvent } from 'react';
import { Input, LabeledContainer } from '@schibsted-svp/react-ui';
import css from './MediaLiveInputInfoDialogSrtSettings.module.scss';

const handleFocus = (event: FocusEvent<HTMLInputElement>) => event.target.select();

type MediaLiveInputInfoDialogSrtSettingsProps = {
    srtSettings?: {
        streamId?: string;
        address?: string;
        port?: string;
        latency?: number;
        algorithm?: string;
        passphrase?: string;
    };
};

export function MediaLiveInputInfoDialogSrtSettings({ srtSettings }: MediaLiveInputInfoDialogSrtSettingsProps) {
    return (
        <div className={css.container}>
            <LabeledContainer label="Passphrase">
                <Input value={srtSettings?.passphrase} onFocus={handleFocus} readOnly />
            </LabeledContainer>
            <LabeledContainer label="Algorithm">
                <Input value={srtSettings?.algorithm} onFocus={handleFocus} readOnly />
            </LabeledContainer>
            <LabeledContainer label="Minimum latency">
                <Input value={srtSettings?.latency} onFocus={handleFocus} readOnly />
            </LabeledContainer>
            <LabeledContainer label="Stream ID">
                <Input value={srtSettings?.streamId} onFocus={handleFocus} readOnly />
            </LabeledContainer>
        </div>
    );
}
